module.exports = __webpack_public_path__ + "media/images/pets5-379b6beb031eaec204f2c17d4ed24f1a.jpg";